import { AttrField, OrmModel, StringField, BooleanField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.RECIPIENT_GROUP)
export default class RecipientGroup<T extends boolean = boolean> extends BaseModel {
  @StringField()
  public id: string

  @AttrField()
  public name: T extends true ? null : string

  @AttrField()
  public membersCount: T extends true ? null : number

  @AttrField()
  public isDeleted: T

  @BooleanField()
  public isTemporary: boolean
}
